import React from "react";
import { useLastThreeNotifications } from "../../hooks/useListLastThreeNotifications";
import { useMarkNotificationAsRead } from "../../hooks/useMarkNotificationAsRead";
import { Notification } from "../../types/api/Notification";
import { useNavigate } from "react-router-dom";
import EyeIcon from "../../assets/icons/EyeIcon";
import { Button, Popover, PopoverContent, PopoverTrigger } from "@nextui-org/react";
import { useTranslation } from "react-i18next";

function NotificationAlert() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { notifications, totalUnRead, listLastThreeNotifications } =
    useLastThreeNotifications();
  const { markNotificationAsRead } = useMarkNotificationAsRead();
  const notificationsLastList = notifications || [];

  React.useEffect(() => {
    if (!notifications) listLastThreeNotifications();
  }, [listLastThreeNotifications, notifications]);

  const handleMarkAsRead = async (notificationId: string) => {
    try {
      await markNotificationAsRead(notificationId);
    } catch (error) {
      console.error("Failed to mark notification as read:", error);
    }
  };

  return (
    <div className="flex items-center mt-4 lg:mt-0 gap-4">
      <Popover placement="bottom-end">
        <PopoverTrigger>
          <Button isIconOnly variant="light" className="relative">
            <div className="relative">
              <svg
                className="w-8 h-7"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 17H20L18.5951 15.5951C18.2141 15.2141 18 14.6973 18 14.1585V11C18 8.38757 16.3304 6.16509 14 5.34142V5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5V5.34142C7.66962 6.16509 6 8.38757 6 11V14.1585C6 14.6973 5.78595 15.2141 5.40493 15.5951L4 17H9M15 17V18C15 19.6569 13.6569 21 12 21C10.3431 21 9 19.6569 9 18V17M15 17H9"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              {totalUnRead > 0 && (
                <span className="absolute -top-1 -right-1 flex">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                  <span
                    className="relative rounded-full bg-red-500 text-white text-xs font-bold flex items-center justify-center"
                    style={{
                      minWidth:
                        totalUnRead >= 100
                          ? "1.8rem"
                          : totalUnRead >= 10
                            ? "1.5rem"
                            : "1.2rem",
                      height: "1.2rem",
                      padding: "0 0.25rem",
                    }}
                  >
                    {totalUnRead > 99 ? "99+" : totalUnRead}
                  </span>
                </span>
              )}
            </div>
          </Button>
        </PopoverTrigger>

        <PopoverContent className="w-80 ">
          <div className="p-4">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">{t("Notifications")}</h3>
              <Button
                size="sm"
                variant="light"
                color="primary"
                onPress={() => navigate("/notifications")}
              >
                {t("SeeAll")}
              </Button>
            </div>

            <div className="space-y-3 max-h-60 overflow-y-auto">
              {notificationsLastList.map((notification: Notification) => (
                <div
                  key={notification.notification_id}
                  className={`p-3 rounded-lg cursor-pointer transition-colors border ${
                    notification.is_read === 0 ? "bg-gray-200" : ""
                  }`}
                  // onClick={() => handleNotificationClick(notification)}
                >
                  <div className="flex justify-between text-start ">
                    <span>
                      {notification.message.length > 15
                        ? `${notification.message}`
                        : notification.message}
                    </span>
                    <EyeIcon
                      onClick={(e) => {
                        e.stopPropagation();
                        if (notification.notification_id) {
                          handleMarkAsRead(notification.notification_id);
                        }
                      }}
                      className="w-4 h-4 text-gray-500"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}

export default NotificationAlert;